import { css } from "@emotion/react";
import { styled } from "../theme";
export const Grid = styled.div `
  display: grid;
  width: 100%;
  grid-column-gap: 10px;
  justify-items: stretch;
  align-items: stretch;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);

    ${({ columnStart }) => columnStart &&
    css `
        grid-column-start: ${columnStart};
      `};
    ${({ columnEnd }) => columnEnd &&
    css `
        grid-column-end: ${columnEnd};
      `};
  }
`;
